'use strict';

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {String} url the url to which the parameter will be added
 * @param {String} name the name of the parameter
 * @param {String} value the value of the parameter
 */
const appendParamToURL = (url, name, value) => {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
};

module.exports = appendParamToURL;
